<template>
	<modal body-classes="p-0" :show="open" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">เปิดใช้งาน 2FA (Two Factor Authentication)</h2>
			</template>
			<template v-if="open">
				<div class="text-center">
					<div class="twoFactor-qrcode">
						<img :src="qrCode" :alt="secret" />
					</div>
				</div>
				<form class="twoFactor-form" @submit.prevent="submitTwoFactor">
					<base-input label="Secret" readOnly v-model="secret" />
					<base-input
						label="OTP Code"
						placeholder="OTP Code"
						v-model="otpCode"
						required
					/>
					<base-button native-type="submit" type="default" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import UserService from '../../services/user.service'

export default {
	props: ['open', 'userID'],
	data() {
		return {
			loading: false,

			secret: '',
			qrCode: '',
			otpCode: '',
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		async submitTwoFactor() {
			this.loading = true

			try {
				const res = await UserService.enable2FA(this.userID, {
					secret: this.secret,
					otpCode: this.otpCode,
				})

				this.$notify({
					type: 'success',
					message: res.message,
				})

				this.$emit('refresh')
				this.$emit('close')
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.loading = false
			}
		},
	},
	watch: {
		async open(v) {
			if (v) {
				try {
					const res = await UserService.generate2FA(this.userID)

					this.secret = res.secret
					this.qrCode = res.qrCode
				} catch ({ message }) {
					this.$notify({
						type: 'danger',
						message: message,
					})
				}
			}
		},
	},
}
</script>
